import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import SEOArticleSection from './components/SEOArticleSection';
import ComparisonGrid from './components/ComparisonGrid';
import CTASection from './components/CTASection';
import Testimonials from './components/Testimonials';

const siteUrl = import.meta.env.VITE_SITE_URL;

const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Kakobuy Finds",
  "url": siteUrl,
  "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png",
  "description": "Kakobuy Finds – najlepsze źródło Kakobuy Spreadsheet, list produktów i poradników zakupowych dla polskich użytkowników.",
  "inLanguage": "pl",
};

const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Kakobuy Finds",
  "url": siteUrl,
  "description": "Kakobuy Spreadsheet Polska – znajdź najlepsze listy produktów, aktualne finds i szczegółowe przewodniki zakupowe. Porównujemy Kakobuy, CSSBuy, Superbuy i Oopbuy.",
  "inLanguage": "pl",
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <SEOArticleSection />
        <ComparisonGrid />
        <CTASection />
        <Testimonials />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteLd) }}
      />
    </>
  );
}